import {FC} from 'react'

type Props = {
  description?: string;
};

const RequestDescriptionTemplate: FC<Props> = ({ description }) => {
  return (
    <div className='card'>
      <div className='card-body mw-xl-75 px-md-5 px-0 pt-0'>
        {description && (
          <div dangerouslySetInnerHTML={{ __html: description }} />
        )}
      </div>
    </div>
  );
};

export {RequestDescriptionTemplate}
